export enum DocumentSystemType {
    DEFAULT = 1,
    PAGE    = 2
}